import React from 'react';
import {getDescriber} from 'src/components/screens/funding/descriptor/walletdescriptor/DescriptorType';
import type {CreditCard} from 'src/models/CreditCard';
import type {Balance} from 'src/models/Balance';
import AccountStore from '../../../../../stores/AccountStore';

interface WalletContentProps {
  creditCards: CreditCard[];
  payrollId?: string;
  displayBalances: Balance[];
  isRefreshing: boolean;
  onRefresh: () => void;
  onCreditCardClick: (card: CreditCard) => void;
  onPayrollClick: () => void;
  onAddCardClick: () => void;
  onAddGiftCardClick: () => void;
}

export const WalletContent: React.FC<WalletContentProps> = ({
  creditCards,
  payrollId,
  displayBalances,
  isRefreshing,
  onRefresh,
  onCreditCardClick,
  onPayrollClick,
  onAddCardClick,
  onAddGiftCardClick,
}) => {
  const descriptor = getDescriber();
  const state = {
    showPayroll: AccountStore.getShowPayroll(),
    payrollPending: !payrollId,
    isRefreshing,
  };
  const props = {creditCards, payrollId, displayBalances};

  return (
    <>
      {descriptor.getWalletCreditCardsSection(
        props,
        state,
        [onCreditCardClick, onPayrollClick, onAddCardClick],
        onRefresh,
      )}
      {descriptor.getWalletBottomSection([onAddGiftCardClick, onAddCardClick])}
    </>
  );
};
